import {BASENAME} from "../constants";
import { trackPromise} from 'react-promise-tracker';

export const ACTION_TYPES = {
    FETCH_USER: "fetch_user",
    FETCH_TERMS: 'fetch_terms',
    ADD_REVIEWER: 'add_reviewer',
    REMOVE_REVIEWER: 'remove_reviewer',
    UPDATE_REVIEWER: 'update_reviewer',
    ADD_CANVAS_USER: 'add_canvas_user',
    REMOVE_CANVAS_USER: 'remove_canvas_user',
    RESET_CANVAS_USERS: 'reset_canvas_users',
    FETCH_COLLEGES: 'fetch_colleges',
    FETCH_PROGRAMS: 'fetch_programs',
    FETCH_OUTCOMES: 'fetch_outcomes',
    FETCH_DEPARTMENTS: 'fetch_departments',
    FETCH_COURSES: 'fetch_courses',
    FETCH_ARTIFACTS: 'fetch_artifacts',
    FETCH_ASSESSMENTS: 'fetch_assesments',
    REMOVE_ASSESSMENT: 'remove_assessment',
    FETCH_ASSESSMENT: 'fetch_assessment',
    FETCH_ALL_ASSESSMENTS: 'fetch_all_assessments',
    FETCH_FILTERED_ASSESSMENTS:'fetch_filtered_assessments',
    UPDATE_ASSESSMENT: 'update_assessment',
    FETCH_REVIEWER_COMMENTS:'fetch_reviewer_comments',
    UPDATE_REVIEWER_COMMENTS: 'update_reviewer_comments',
    DELETE_REVIEWER_COMMENT:'delete_reviewer_comment',
    SWAP_ARTIFACT: 'swap_artifact',
    SET_FIELDS: {
        SET_NAME: 'name',
        SET_COLLEGE: 'college',
        SET_PROGRAM: 'program',
        SET_OUTCOME: 'outcome',
        SET_DEPARTMENT: 'department',
        ADD_COURSE: 'add_course',
        REMOVE_COURSE: 'remove_course',
        SET_NUM_ARTIFACTS: 'artifacts',
        SET_MULTI: 'multi',
        SET_TERM: 'terms',
        SET_RUBRIC: 'set_rubric',
        SET_REVIEWERS: 'set_reviewers',
        SET_NUM_ARTIFACTS_PER_REVIEWER: 'artifacts_per_reviewer',
        SET_FILTER_INPUTS:'set_filter_inputs',
        // SET_FILTERED_PAGE: 'set_filtered_page',
        // SET_FILTERED_LIMIT: 'set_filtered_limit',
        SET_IS_ALL_ASSESSMENTS_VIEW: 'set_is_all_assessments_view',
        SET_NUM_ARTIFACTS_PER_TIER: 'artifacts_per_tier',
        SET_BELL_CURVE_CHECKED: 'set_bell_curve_checked',
    },
    UPDATE_RUBRICS: 'update_rubrics',
    RESET_RUBRICS: 'reset_rubrics',
    FETCH_REVIEWS: 'fetch_reviews',
    SAVE_RUBRIC: 'save_rubric',
    DELETE_RUBRIC: 'delete_rubric',
    RESET_RUBRIC_LIST: 'reset_rubric_list',
    FETCH_RUBRICS: 'fetch_rubrics'
};

export const actions = {
    fetchUser: () => async (dispatch) => {
        let payload = null;
        try {
            const res = await fetch(BASENAME + '/api/current_user');
            payload = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({type: ACTION_TYPES.FETCH_USER, payload});
    },
    addReviewer: (reviewer) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.ADD_REVIEWER,
            payload: reviewer
        });
    },
    removeReviewer: (reviewer) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.REMOVE_REVIEWER,
            payload: reviewer
        });
    },
    updateReviewer: (reviewer) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.UPDATE_REVIEWER,
            payload: reviewer
        });
    },
    addCanvasUser: (canvasUser) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.ADD_CANVAS_USER,
            payload: canvasUser
        });
    },
    removeCanvasUser: (canvasUser) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.REMOVE_CANVAS_USER,
            payload: canvasUser
        });
    },
    resetCanvasUsers: () => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.RESET_CANVAS_USERS,
            payload: []
        });
    },
    fetchColleges: () => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/colleges'));
            payload.colleges = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_COLLEGES,
            payload
        });
    },
    fetchTerms: () => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/terms'));
            payload = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_TERMS,
            payload
        });
    },
    fetchDepartments: (collegeid) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/departments/' + collegeid));
            payload.departments = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_DEPARTMENTS,
            payload
        });
    },
    fetchDepartmentsPerUser: () => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/departmentsPerUser'));
            payload.departments = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_DEPARTMENTS,
            payload
        });
    },
    fetchPrograms: (departmentid) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/programs/' + departmentid));
            payload.programs = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_PROGRAMS,
            payload
        });
    },
    fetchOutcomes: (programid) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/outcomes/' + programid));
            payload.outcomes = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_OUTCOMES,
            payload
        });
    },
    fetchCourses: (query) => async (dispatch) => {
        let payload = {};
        if(query.outcome_id && query.terms && query.terms.length > 0) {
            try {
                let body = JSON.stringify({
                    outcome_id: query.outcome_id,
                    program_id: query.program_id,
                    terms: query.terms,
                    isAbet: query.isAbet,
                });
                const res = await trackPromise(fetch(BASENAME + '/api/coursesbyprogram', {
                    method: "post",
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: body
                }))
                payload.courses = await res.json();
            } catch (err) {

            }
            return dispatch({
                type: ACTION_TYPES.FETCH_COURSES,
                payload
            });
        }
    },
    setNewFields: (field) => async (dispatch) => {
        return dispatch({
            type: field.type,
            payload: field.payload
        })
    },
    fetchArtifacts: (form) => async (dispatch) => {
        let payload = {};
        try {
            let body = JSON.stringify({
                outcome_id: form.outcome.id,
                canvas_courses: form.courses,
                numArtifacts: form.numArtifacts,
                numArtifactsPerTier:parseInt(form.numArtifactsPerTier),
                isTiered:form.checked
            });
            const res = await trackPromise(fetch(BASENAME + '/api/getartifacts', {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: body
            }))
            payload.artifacts = await res.json();
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.FETCH_ARTIFACTS,
            payload
        });
    },
    swapArtifact: (form) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/swapartifact', {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(form)
            }))
            payload.artifact = await res.json();
            payload.old_artifact_id = form.canvas_submission_id;
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.SWAP_ARTIFACT,
            payload
        });
    },
    fetchAssessments: (query) => async (dispatch) => {
        console.log('the query params', query);
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/assessments_per_user/' + query.unid + '?fetchType=assessmentsPerUser&page=' + query.page + '&limit=' + query.limit+'&queryType=AssessmentsPerUser'));
            payload.assessments = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_ASSESSMENTS,
            payload
        });
    },
    fetchFilteredAssessments:(query)=>async(dispatch)=>{
        try {
            const res = await trackPromise(fetch(BASENAME+'/api/filtered_assessments/?fetchType=filtered&page=' + query.page + '&limit=' + query.limit + '&filterBy=' + query.filterBy + '&fetchId=' + query.fetchId +'&fetchName=' + query.fetchName))
            if(res.status==200){
                const assessments = await res.json();
                const payload = assessments;
                dispatch({
                    type:ACTION_TYPES.FETCH_FILTERED_ASSESSMENTS,
                    payload
                });
                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_MULTI,
                    payload
                })
            }
        }catch(err){

        }
    },
    //payload will be array of all assessment objects
    fetchAllAssessments:(query)=>async(dispatch)=>{
        try {
            const res = await trackPromise(fetch(BASENAME+'/api/all_assessments/?fetchType=allAssessments&page=' + query.page + '&limit=' + query.limit));
            if(res.status == 200){
                const assessments = await res.json();
                const payload = assessments;
                return dispatch({
                    type:ACTION_TYPES.FETCH_ALL_ASSESSMENTS,
                    payload
                });
            }
        } catch (err) {
        // do nothing
        }
    },
    fetchAssessment: (assessment_id) => async (dispatch) => {
        let payload = {};
        let assessment = {};
        try {
            let res = await trackPromise(fetch(BASENAME + '/api/assessment/' + assessment_id));
            if(res.status == 200) {
                assessment = await res.json();
                payload = assessment;

                dispatch({
                    type: ACTION_TYPES.FETCH_ARTIFACTS,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_RUBRIC,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_REVIEWERS,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.FETCH_COURSES,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_MULTI,
                    payload
                })
            }
        } catch (err) {
            // do nothing
        }
    },
    fetchReview: (assessment_id) => async (dispatch) => {
        let payload = {};
        let assessment = {};
        try {
            let res = await trackPromise(fetch(BASENAME + '/api/review/' + assessment_id));
            if(res.status == 200) {
                assessment = await res.json();
                payload = assessment;

                dispatch({
                    type: ACTION_TYPES.FETCH_ARTIFACTS,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_RUBRIC,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_REVIEWERS,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.FETCH_COURSES,
                    payload
                });

                dispatch({
                    type: ACTION_TYPES.SET_FIELDS.SET_MULTI,
                    payload
                })
            } else {}
        } catch (err) {
            // do nothing
        }
    },
    setAssessment: (payload) => (dispatch) => {
        dispatch({
            type: ACTION_TYPES.FETCH_ARTIFACTS,
            payload
        });

        dispatch({
            type: ACTION_TYPES.SET_FIELDS.SET_RUBRIC,
            payload
        });

        dispatch({
            type: ACTION_TYPES.SET_FIELDS.SET_REVIEWERS,
            payload
        });

        dispatch({
            type: ACTION_TYPES.FETCH_COURSES,
            payload
        });

        dispatch({
            type: ACTION_TYPES.SET_FIELDS.SET_MULTI,
            payload
        })
    },
    updateAssessment: (assessment_id, body) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/assessment/' + assessment_id, {
                method: "put",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify(body)
            }));
            payload = await res.json();
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.UPDATE_ASSESSMENT,
            payload
        });

    },
    removeAssessment: (assessment_id) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/assessment/' + assessment_id, {
                method: "delete",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }))
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.REMOVE_ASSESSMENT,
            payload: assessment_id
        });

    },

    updateReviewerComments: (body, assessment_id, reviewer_unid) => async(dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/comments/' + assessment_id + '/' +reviewer_unid, {
                method: "put",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify(body)
            }));
            payload = await res.json();
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.UPDATE_ASSESSMENT,
            payload
        });
    },

    deleteReviewerComment:(assessment_id,reviewer_unid,comment_id)=>async(dispatch)=>{
        let payload = {};
        console.log('inside action to delete comment');
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/comments/' + assessment_id + '/' +reviewer_unid, {
                method: "delete",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },

                body: JSON.stringify({commentId:comment_id})
            }));
            payload = await res.json();
        } catch (err) {

        }
        return dispatch({
            type: ACTION_TYPES.UPDATE_ASSESSMENT,
            payload
        });
    },

    fetchReviewerComments:(assessment_id, reviewer_unid)=>async(dispatch)=>{
        let payload ={};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/comments/' + assessment_id + '/' +reviewer_unid));
            payload = await res.json();
        } catch (err) {
            console.log('error fetching comments', err);
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_REVIEWER_COMMENTS,
            payload
        });
    },

    updateRubrics: (criteria) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.UPDATE_RUBRICS,
            payload: criteria
        });
    },
    resetRubrics: (criteria) => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.RESET_RUBRICS,
            payload: criteria
        })
    },
    resetRubricsList: () => (dispatch) => {
        return dispatch({
            type: ACTION_TYPES.RESET_RUBRIC_LIST,
            payload: []
        })
    },
    saveRubric: (rubric) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/rubrics/' + rubric.outcome_id, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(rubric)
            }))
            payload = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.SAVE_RUBRIC,
            payload
        });
    },
    deleteRubric: (rubric_id) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/rubric/' + rubric_id, {
                method: "delete",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }))
            payload = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.DELETE_RUBRIC,
            payload
        });
    },
    fetchReviews: (query) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/reviews_per_user/' + query.unid + '?page=' + query.page + '&limit=' + query.limit));
            payload.reviews = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_REVIEWS,
            payload
        });
    },
    fetchRubrics: (outcome_id) => async (dispatch) => {
        let payload = {};
        try {
            const res = await trackPromise(fetch(BASENAME + '/api/rubrics/' + outcome_id));
            payload = await res.json();
        } catch (err) {
            // do nothing
        }
        return dispatch({
            type: ACTION_TYPES.FETCH_RUBRICS,
            payload
        });
    }
};


